"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadConfig = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
const styles_1 = require("@mui/material/styles");
const theme_1 = __importDefault(require("../../theme"));
const useSetConfig_1 = require("../../hooks/useSetConfig");
const useSetSidebar_1 = require("../../hooks/useSetSidebar");
const util_1 = require("../../services/util");
const Api_1 = __importDefault(require("../../services/Api"));
const Error_1 = __importDefault(require("../parts/Error"));
const mockData_1 = require("../../store/mockData");
const FeesableSnackbar_1 = require("../FeesableSnackbar/FeesableSnackbar");
const useSetCalcResponse_1 = require("../../hooks/useSetCalcResponse");
const LoadConfig = (0, react_1.memo)(({ schoolId, defaultData, children }) => {
    const [configLoading, setConfigLoading] = (0, react_1.useState)(true);
    const [configLoadFailure, setConfigLoadFailure] = (0, react_1.useState)(false);
    const setConfig = (0, useSetConfig_1.useSetConfig)();
    const setSidebar = (0, useSetSidebar_1.useSetSidebar)();
    const [configTheme, setConfigTheme] = (0, react_1.useState)(theme_1.default);
    const triggerSnackbar = (0, FeesableSnackbar_1.useSnackbar)().triggerSnackbar;
    const setCalcResponse = (0, useSetCalcResponse_1.useSetCalcResponse)();
    //pulls in config loaded by the hosted app
    const updateTheme = (newTheme) => {
        // TODO: This only does shallow clone. Use Immer as we are already using it in other places.
        const updatedTheme = Object.assign({}, theme_1.default);
        // TODO: Use values from the theme as the default values instead of hardcoding.
        updatedTheme.palette.primary.main = newTheme.primary || '#00BCD4';
        updatedTheme.palette.primary.light = newTheme.primaryLight || '#E0F7FA';
        updatedTheme.palette.primary.dark = newTheme.primary || '#00BCD4';
        updatedTheme.palette.primary.contrastText =
            newTheme.primaryContrast || '#FFFFFF';
        updatedTheme.palette.custom.panelSurface =
            newTheme.panelSurface || '#E5F1F5';
        updatedTheme.palette.custom.panelText = newTheme.panelText || '#07769B';
        updatedTheme.palette.custom.surfaceLight =
            newTheme.surfaceLight || '#FFFFFF';
        updatedTheme.palette.custom.surfaceMedium =
            newTheme.surfaceMedium || '#F5F5F5';
        updatedTheme.palette.custom.surfaceDark =
            newTheme.surfaceDark || '#C6ECF1';
        updatedTheme.palette.custom.primary = newTheme.primary || '#00BCD4';
        updatedTheme.palette.custom.primaryMedium =
            newTheme.primaryMedium || '#B2EBF2';
        updatedTheme.palette.custom.primaryLight =
            newTheme.primaryLight || '#E0F7FA';
        updatedTheme.palette.custom.text = newTheme.text || '#212121';
        updatedTheme.palette.custom.textMedium = newTheme.textMedium || '#424242';
        updatedTheme.palette.custom.textLight = newTheme.textLight || '#757575';
        setConfigTheme(updatedTheme);
    };
    // const params = new URLSearchParams(window.location.search)
    // // use specific config / fee id
    // const preview = params.get('preview') || undefined
    (0, react_1.useEffect)(() => {
        const setupConfig = (response) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const config = Object.assign(Object.assign({}, defaultData), response.data);
            if (((_c = (_b = (_a = config.features) === null || _a === void 0 ? void 0 : _a.move) === null || _b === void 0 ? void 0 : _b.setup) === null || _c === void 0 ? void 0 : _c.isDemo) || defaultData.testMode) {
                config.inputData = mockData_1.mockInput;
                setSidebar({
                    show: config.includeSidebar,
                    display: ['contact', 'demo'],
                });
                setCalcResponse(false, mockData_1.mockResponse);
            }
            setSidebar({ show: config.includeSidebar });
            setConfig(config);
            if ((_f = (_e = (_d = config.features) === null || _d === void 0 ? void 0 : _d.move) === null || _e === void 0 ? void 0 : _e.setup) === null || _f === void 0 ? void 0 : _f.cssOverride) {
                (0, util_1.createStyleTag)((_h = (_g = config.features) === null || _g === void 0 ? void 0 : _g.move) === null || _h === void 0 ? void 0 : _h.setup.cssOverride);
            }
            updateTheme(config.theme);
            setConfigLoading(false);
        };
        setConfigLoading(true);
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            setConfigLoading(true);
            try {
                const data = yield Api_1.default.getSchoolConfig(schoolId);
                setupConfig(data);
            }
            catch (error) {
                triggerSnackbar('Failed to fetch school configuration.', 'error');
                setConfigLoadFailure(true);
            }
            finally {
                setConfigLoading(false);
            }
        });
        fetchData();
    }, [schoolId]);
    if (configLoading) {
        return ((0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, sx: { background: 'white', marginTop: '10%' }, children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, xs: 1, md: true }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, xs: 10, md: 8, children: (0, jsx_runtime_1.jsx)(LinearProgress_1.default, { color: "primary", sx: {
                            height: '20px',
                            borderRadius: '10px',
                        } }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, xs: 1, md: true })] }));
    }
    if (configLoadFailure) {
        return (0, jsx_runtime_1.jsx)(Error_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(styles_1.ThemeProvider, { theme: configTheme, children: [(0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), children] }));
});
exports.LoadConfig = LoadConfig;
LoadConfig.displayName = 'LoadConfig';
